// @ts-ignore
import { track } from 'lib/analytics'
import { CurrentUser } from '../global'

/**
 * Derive the user's current role from the passed currentUser object.
 * @returns A new Avo collaborator role event value
 */
export function getCollaboratorRole(currentUser: CurrentUser) {
  if (currentUser) {
    const role = currentUser?.currentRegistry?.currentUserRole

    if (role === 'partner') {
      return track.CollaboratorRole.PARTNER
    }

    if (role === 'owner') {
      return track.CollaboratorRole.REGISTRANT
    }

    if (role === 'collaborator') {
      return track.CollaboratorRole.COLLABORATOR
    }
  }

  return undefined
}

/**
 * Get the Avo Product type.
 * @returns An Avo ProductType property value
 */
export function getProductType(isGiftCard: boolean) {
  return isGiftCard ? track.ProductType.GIFT_CARD : track.ProductType.PRODUCT
}
